// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","content":"Footer_content__aJpHx","socials":"Footer_socials__7h4n1"};